
const AuthWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    return <>{children}</>;
  };

export default AuthWrapper;